import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

export const CompanyDataCta = () => {
  const { t } = useInt();

  return (
    <CtaSection
      spotlight
      title={t('Point your agent at a company you already know and check the filing it returns.')}
      description={t(
        'That is the fastest evaluation there is. A test key is issued from the platform, the MCP server connects in minutes, and bulk extracts are scoped with our team.',
      )}
      actions={
        <>
          <Button type="blue" size="xl" rounded="full" href="https://platform.globaldatabase.com/app-api/api">
            {t('Request API access')}
          </Button>
          <Button type="dark-outline" size="xl" rounded="full" href="/mcp-integration">
            {t('Connect the MCP server')}
          </Button>
          <Button type="dark-outline" size="xl" rounded="full" href="/book-a-demo">
            {t('Scope a bulk feed')}
          </Button>
        </>
      }
    />
  );
};
